import { EventEntity } from './event-service.data'

export enum IApiDbActionCode {
    Insert = 'i',
    Update = 'u',
    Delete = 'd',
    Transaction = 't',
}



export type IApiEventDiffColumn = {
    k: string,
    o: any,
    n: any,
}

export type IApiChangeHistoryEvent<T = unknown> = {
    id: number,
    transactionId: string,
    schemaName: string,
    entity: EventEntity,
    dbActionCode: IApiDbActionCode,
    entityId: number,
    createdAtUtc: Date,
    authorId: number,
    info: T,
    diff: IApiEventDiffColumn[],
    userActionCode: string,
}

export type IApiGetEventListParams = {
    schemaName: string,
    entity: EventEntity,
    entityId: number,
    transactionId: number,
    action: string,
    actionCodes: string[],
    isForward: boolean,
    pageSize: number,
    fromId: number,
    fromUtc: Date,
    toUtc: Date,
}


export type IApiGetColumnListParams = {
    schemaName: string,
    entity: string,
}

export type IApiColumnInfo = {
    id: number,
    schemaName: string,
    entity: string,
    columnName: string,
    info: IApiColumnProps,
}

export type BooleanValueSettings = {
    trueText?: string,
    falseText?: string,
    emptyText?: string,
}

export type DateValueSettings = {
    format?: string,
    emptyText?: string,
}

export type JsonValueSettings = {
    emptyText?: string,
    schemaName?: string,
}

export type IdentifierValueSettings = {
    table: string,
    entity: string,
    emptyText?: string,
}

export type EnumValueSettings = {
    dictName?: string,
    emptyText?: string,
}

export type IApiColumnProps = {
    title: string,
    isHide?: boolean,
    type?: IApiColumnType,
    boolProps?: BooleanValueSettings,
    dateProps?: DateValueSettings,
    jsonProps?: JsonValueSettings,
    enumProps?: EnumValueSettings,
    idProps?: IdentifierValueSettings,
}

export enum IApiColumnType {
    Unknown = '',
    Identifier = 'id',
    String = 'string',
    Number = 'number',
    Boolean = 'bool',
    Json = 'json',
    Enum = 'enum',
    Date = 'date',
    UserId = 'userId',
}